import React, { useEffect, useState } from 'react';

const PDFOverlay = ({ 
  selectedCells = [], 
  textractMetadata, 
  pageNumber, 
  currentPage,
  viewerContainer 
}) => {
  const [bounds, setBounds] = useState(null);

  // Vertical offset correction (in pixels)
  const VERTICAL_OFFSET_CORRECTION = 104; 

  useEffect(() => {
    // console.log('PDFOverlay effect triggered:', {
    //     hasSelectedCells: selectedCells.length > 0,
    //     hasMetadata: !!textractMetadata,
    //     hasContainer: !!viewerContainer,
    //     pageMatch: (currentPage + 1) === pageNumber,
    //     currentPage,
    //     pageNumber
    // });

    if (!selectedCells.length || !textractMetadata || !viewerContainer || (currentPage + 1) !== pageNumber) {
        console.log('Early return condition met');
        setBounds(null);
        return;
    }

    // Enhanced cell bounds extraction with better error handling
    const cellBounds = selectedCells.map(({ row, col }) => {
      // First check if textractMetadata.cells exists and has data for this row
      if (!textractMetadata.cells || 
          !Array.isArray(textractMetadata.cells) || 
          row >= textractMetadata.cells.length) {
        console.log(`No metadata for row ${row}`);
        return null;
      }
      
      // Then check if this row has data for this column
      if (!textractMetadata.cells[row] || 
          !Array.isArray(textractMetadata.cells[row]) || 
          col >= textractMetadata.cells[row].length) {
        console.log(`No metadata for cell [${row},${col}]`);
        return null;
      }
      
      // Finally, get the boundingBox if it exists
      const cellMetadata = textractMetadata.cells[row][col];
      if (!cellMetadata || !cellMetadata.boundingBox) {
        console.log(`No bounding box for cell [${row},${col}]`);
        return null;
      }
      
      return cellMetadata.boundingBox;
    }).filter(Boolean);

    console.log('Valid cell bounds found:', cellBounds.length);

    if (!cellBounds.length) {
        console.log('No valid cell bounds found, selection may contain added rows/columns');
        setBounds(null);
        return;
    }

    // Calculate the combined bounding box
    const minLeft = Math.min(...cellBounds.map(box => box.Left));
    const maxRight = Math.max(...cellBounds.map(box => box.Left + box.Width));
    const minTop = Math.min(...cellBounds.map(box => box.Top));
    const maxBottom = Math.max(...cellBounds.map(box => box.Top + box.Height));

    console.log('Combined bounds:', { minLeft, maxRight, minTop, maxBottom });

    // Get viewer dimensions
    const containerRect = viewerContainer.getBoundingClientRect();
    const pageWidth = containerRect.width;
    const pageHeight = containerRect.height;

    // Calculate the original dimensions without any scaling
    const boxWidth = (maxRight - minLeft) * pageWidth;
    const boxHeight = (maxBottom - minTop) * pageHeight;

    // Calculate position with vertical offset correction
    const boxLeft = containerRect.left + (minLeft * pageWidth);
    const boxTop = containerRect.top + (minTop * pageHeight) - VERTICAL_OFFSET_CORRECTION;

    console.log('Container dimensions:', {
        rect: containerRect,
        pageWidth,
        pageHeight
    });

    // Log detailed positioning info for debugging
    console.log('Positioning details:', {
        originalTop: containerRect.top + (minTop * pageHeight),
        correctedTop: boxTop,
        verticalOffset: VERTICAL_OFFSET_CORRECTION,
        boxWidth,
        boxHeight
    });

    const newBounds = {
        left: boxLeft,
        top: boxTop,
        width: boxWidth,
        height: boxHeight
    };
    
    console.log('Setting new bounds:', newBounds);
    setBounds(newBounds);

  }, [selectedCells, textractMetadata, pageNumber, currentPage, viewerContainer]);

  if (!bounds) return null;

  return (
    <div
      className="absolute pointer-events-none border-2 border-blue-500 bg-blue-500/20"
      style={{
        left: bounds.left,
        top: bounds.top,
        width: bounds.width,
        height: bounds.height,
        transition: 'all 0.2s ease-in-out'
      }}
    />
  );
};

export default PDFOverlay;